// import React from 'react'

// const ProfileForm = ({ user, onInputChange }) => (
//     <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
//       <div className="space-y-2">
//         <label className="block text-sm font-medium text-gray-700">Address</label>
//         <input
//           type="text"
//           name="address"
//           onChange={onInputChange}
//           placeholder={user.address}
//           disabled={true}
//           className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//         />
//       </div>
//       <div className="space-y-2">
//         <label className="block text-sm font-medium text-gray-700">Contact Number</label>
//         <input
//           type="text"
//           name="phoneNumber"
//           onChange={onInputChange}
//           placeholder={user.phoneNumber}
//           disabled={true}
//           className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//         />
//       </div>
//     </div>
//   );
  

// export default ProfileForm


import React, { useState, useEffect } from "react";
import { EMPLOYER_URL } from "../../resources/resource";


// ── icons (inline SVG, no extra deps) ──────────────────────────────────────
const Icon = ({ d, size = 16, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    className={className}
  >
    <path d={d} />
  </svg>
);

const icons = {
  building:
    "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10",
  mapPin: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z M12 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
  phone: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.1 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.09 9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21 16.92z",
  mail: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6",
  users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
  briefcase:
    "M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2",
  shield:
    "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  edit: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
  check: "M20 6L9 17l-5-5",
  x: "M18 6L6 18 M6 6l12 12",
  whatsapp: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z M11.93 2C6.44 2 2 6.44 2 11.93a9.93 9.93 0 0 0 1.412 5.09L2 22l5.13-1.381A9.91 9.91 0 0 0 11.93 21.86c5.49 0 9.93-4.44 9.93-9.93C21.86 6.44 17.42 2 11.93 2z",
};

// ── helpers ─────────────────────────────────────────────────────────────────
const badge = (label, color = "blue") => {
  const colors = {
    blue: "bg-blue-100 text-blue-700",
    green: "bg-emerald-100 text-emerald-700",
    red: "bg-red-100 text-red-700",
    gray: "bg-slate-100 text-slate-600",
    amber: "bg-amber-100 text-amber-700",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[color]}`}
    >
      {label}
    </span>
  );
};

// ── section wrapper ──────────────────────────────────────────────────────────
const Section = ({ iconPath, title, children, accent = false }) => (
  <div
    className={`bg-white rounded-xl border ${
      accent ? "border-blue-200" : "border-slate-200"
    } overflow-hidden`}
  >
    <div
      className={`flex items-center gap-3 px-5 py-4 border-b ${
        accent ? "border-blue-100 bg-blue-50" : "border-slate-100 bg-slate-50"
      }`}
    >
      <span
        className={`flex-shrink-0 p-1.5 rounded-lg ${
          accent ? "bg-blue-100 text-blue-600" : "bg-slate-200 text-slate-600"
        }`}
      >
        <Icon d={iconPath} size={15} />
      </span>
      <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

// ── field ────────────────────────────────────────────────────────────────────
const Field = ({
  label,
  name,
  value,
  onChange,
  editing,
  type = "text",
  options,
  required,
  hint,
}) => {
  const base =
    "w-full px-3 py-2.5 text-sm rounded-lg border transition-all duration-150 outline-none";
  const active =
    "border-blue-300 bg-white text-slate-900 focus:ring-2 focus:ring-blue-200 focus:border-blue-400";
  const disabled =
    "border-slate-200 bg-slate-50 text-slate-700 cursor-default";

  return (
    <div className="space-y-1.5">
      <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wide">
        {label}
        {required && editing && (
          <span className="text-red-400 ml-0.5">*</span>
        )}
      </label>

      {options ? (
        <select
          name={name}
          value={value ?? ""}
          onChange={onChange}
          disabled={!editing}
          className={`${base} ${editing ? active : disabled}`}
        >
          <option value="">Select…</option>
          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          name={name}
          value={value ?? ""}
          onChange={onChange}
          disabled={!editing}
          rows={3}
          className={`${base} ${editing ? active : disabled} resize-none`}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          disabled={!editing}
          className={`${base} ${editing ? active : disabled}`}
        />
      )}

      {hint && <p className="text-xs text-slate-400">{hint}</p>}
    </div>
  );
};

// ── service card ─────────────────────────────────────────────────────────────
const ServiceCard = ({ service, idx }) => (
  <div className="border border-slate-200 rounded-lg p-4 space-y-2 bg-slate-50">
    <div className="flex items-start justify-between gap-2 flex-wrap">
      <span className="font-medium text-slate-800 text-sm">
        {service.serviceName || `Service ${idx + 1}`}
      </span>
      <div className="flex gap-1.5 flex-wrap">
        {service.homeService && badge("Home Service", "green")}
        {service.amountCharged &&
          badge(`₦${service.amountCharged.toLocaleString()}`, "blue")}
      </div>
    </div>
    {service.duration && (
      <p className="text-xs text-slate-500">Duration: {service.duration}</p>
    )}
    {service.yearsExperience != null && (
      <p className="text-xs text-slate-500">
        {service.yearsExperience} yr{service.yearsExperience !== 1 ? "s" : ""}{" "}
        experience
      </p>
    )}
    {service.aboutUs && (
      <p className="text-xs text-slate-600 leading-relaxed">{service.aboutUs}</p>
    )}
  </div>
);

// ── main component ───────────────────────────────────────────────────────────
const ProfileForm = ({ user, onInputChange }) => {
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null); // { type: 'success'|'error', msg }

  // Seed form whenever user prop changes
  useEffect(() => {
    if (user) setForm({ ...user });
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    onInputChange?.(e);
  };

  const showToast = (type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast(null), 3500);
  };

  const handleCancel = () => {
    setForm({ ...user });
    setEditing(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}jobrecruiter/updateJobEmployer/${user._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            companyName: form.companyName,
            email: form.email,
            phoneNumber: form.phoneNumber,
            whatsappNumber: form.whatsappNumber,
            address: form.address,
            state: form.state,
            localGovernment: form.localGovernment,
            country: form.country,
            size: form.size,
            employerType: form.employerType,
            userType: form.userType,
            aboutUs: form.aboutUs,
          }),
        }
      );

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || "Update failed");
      }

      setEditing(false);
      showToast("success", "Profile updated successfully.");
    } catch (err) {
      showToast("error", err.message || "Something went wrong.");
    } finally {
      setSaving(false);
    }
  };

  if (!user && !Object.keys(form).length) {
    return (
      <div className="flex items-center justify-center py-16 text-slate-400 text-sm">
        Loading profile…
      </div>
    );
  }

  const f = form;

  return (
    <div className="space-y-5 relative">
      {/* ── toast ── */}
      {toast && (
        <div
          className={`fixed top-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg text-sm font-medium transition-all ${
            toast.type === "success"
              ? "bg-emerald-600 text-white"
              : "bg-red-600 text-white"
          }`}
        >
          <Icon d={toast.type === "success" ? icons.check : icons.x} size={15} />
          {toast.msg}
        </div>
      )}

      {/* ── toolbar ── */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-base font-semibold text-slate-900">
            Company Profile
          </h2>
          <p className="text-xs text-slate-500 mt-0.5">
            {editing
              ? "Edit the fields below, then save."
              : "View and manage your employer details."}
          </p>
        </div>

        <div className="flex gap-2">
          {editing ? (
            <>
              <button
                onClick={handleCancel}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg border border-slate-300 text-sm font-medium text-slate-700 hover:bg-slate-50 transition"
              >
                <Icon d={icons.x} size={14} />
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={saving}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition disabled:opacity-60"
              >
                {saving ? (
                  <svg
                    className="animate-spin"
                    width={14}
                    height={14}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>
                ) : (
                  <Icon d={icons.check} size={14} />
                )}
                {saving ? "Saving…" : "Save Changes"}
              </button>
            </>
          ) : (
            <button
              onClick={() => setEditing(true)}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition"
            >
              <Icon d={icons.edit} size={14} />
              Edit Profile
            </button>
          )}
        </div>
      </div>

      {/* ── status badges ── */}
      <div className="flex flex-wrap gap-2">
        {f.isVerified && badge("Verified", "green")}
        {f.addressVerified && badge("Address Verified", "green")}
        {f.businessVerified && badge("Business Verified", "blue")}
        {f.isBlacklisted && badge("Blacklisted", "red")}
        {f.registrationMethod && badge(f.registrationMethod, "gray")}
        {f.userType && badge(f.userType, "amber")}
      </div>

      {/* ── 1. Company Info ── */}
      <Section iconPath={icons.building} title="Company Information" accent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field
            label="Company Name"
            name="companyName"
            value={f.companyName}
            onChange={handleChange}
            editing={editing}
            required
          />
          <Field
            label="Email Address"
            name="email"
            value={f.email}
            onChange={handleChange}
            editing={editing}
            type="email"
            required
          />
          <Field
            label="Company Size"
            name="size"
            value={f.size}
            onChange={handleChange}
            editing={editing}
            options={[
              "1-10",
              "11-50",
              "51-200",
              "201-500",
              "501-1000",
              "1000+",
            ]}
            required
          />
          <Field
            label="Employer Type"
            name="employerType"
            value={f.employerType}
            onChange={handleChange}
            editing={editing}
            options={["Individual", "Company", "Agency", "NGO", "Government"]}
            required
          />
          <Field
            label="User Type"
            name="userType"
            value={f.userType}
            onChange={handleChange}
            editing={editing}
          />

            <div className="mt-4">
    <Field
      label="About Us"
      name="aboutUs"
      value={f.aboutUs}
      onChange={handleChange}
      editing={editing}
      type="textarea"
      hint="A short description of your company — shown on your public profile"
    />
  </div>
        </div>
      </Section>

      {/* ── 2. Contact ── */}
      <Section iconPath={icons.phone} title="Contact Details">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field
            label="Phone Number"
            name="phoneNumber"
            value={f.phoneNumber}
            onChange={handleChange}
            editing={editing}
            type="tel"
            required
          />
          <Field
            label="WhatsApp Number"
            name="whatsappNumber"
            value={f.whatsappNumber}
            onChange={handleChange}
            editing={editing}
            type="tel"
            hint="Optional — used for direct messaging"
          />
        </div>
      </Section>

      {/* ── 3. Location ── */}
      <Section iconPath={icons.mapPin} title="Location">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2">
            <Field
              label="Street Address"
              name="address"
              value={f.address}
              onChange={handleChange}
              editing={editing}
              required
            />
          </div>
          <Field
            label="State"
            name="state"
            value={f.state}
            onChange={handleChange}
            editing={editing}
            required
          />
          <Field
            label="Local Government"
            name="localGovernment"
            value={f.localGovernment}
            onChange={handleChange}
            editing={editing}
            required
          />
          <Field
            label="Country"
            name="country"
            value={f.country}
            onChange={handleChange}
            editing={editing}
            required
          />
        </div>
      </Section>

      {/* ── 4. Verification ── */}
      <Section iconPath={icons.shield} title="Verification & Security">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200 bg-slate-50">
            <span className="text-sm text-slate-700">Email Verified</span>
            {f.isVerified
              ? badge("Yes", "green")
              : badge("No", "red")}
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200 bg-slate-50">
            <span className="text-sm text-slate-700">Address Verified</span>
            {f.addressVerified
              ? badge("Yes", "green")
              : badge("No", "red")}
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200 bg-slate-50">
            <span className="text-sm text-slate-700">Business Verified</span>
            {f.businessVerified
              ? badge("Yes", "green")
              : badge("No", "red")}
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg border border-slate-200 bg-slate-50">
            <span className="text-sm text-slate-700">Blacklisted</span>
            {f.isBlacklisted
              ? badge("Yes", "red")
              : badge("No", "green")}
          </div>
        </div>

        {/* Face Auth History */}
        {Array.isArray(f.faceAuthHistory) && f.faceAuthHistory.length > 0 && (
          <div className="mt-5">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-3">
              Face Auth History
            </p>
            <div className="space-y-2 max-h-40 overflow-y-auto pr-1">
              {f.faceAuthHistory.map((entry, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between text-xs py-2 px-3 rounded-md border border-slate-100 bg-white"
                >
                  <span className="text-slate-500">
                    {entry.timestamp
                      ? new Date(entry.timestamp).toLocaleString()
                      : "—"}
                  </span>
                  <span className="text-slate-600 font-medium">
                    {entry.action}
                  </span>
                  <span>
                    {entry.verified
                      ? badge("Verified", "green")
                      : badge("Failed", "red")}
                  </span>
                  {entry.livenessScore != null && (
                    <span className="text-slate-400">
                      {(entry.livenessScore * 100).toFixed(0)}%
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </Section>

      {/* ── 5. Activity Stats ── */}
      <Section iconPath={icons.briefcase} title="Activity Overview">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {[
            {
              label: "Listed Jobs",
              value: f.listedJobs?.length ?? 0,
            },
            {
              label: "Employees",
              value: f.employers?.length ?? 0,
            },
            {
              label: "Followers",
              value: f.followerCount ?? f.followers?.length ?? 0,
            },
            {
              label: "Job Offers",
              value: f.jobOffers?.length ?? 0,
            },
            {
              label: "Reports Made",
              value: f.reportsMade?.length ?? 0,
            },
            {
              label: "Reports Received",
              value: f.reportsGotten?.length ?? 0,
            },
          ].map(({ label, value }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center p-3 rounded-lg border border-slate-200 bg-slate-50 text-center"
            >
              <span className="text-xl font-bold text-blue-600">{value}</span>
              <span className="text-xs text-slate-500 mt-0.5">{label}</span>
            </div>
          ))}
        </div>

        {/* Dates */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
          <div className="p-3 rounded-lg border border-slate-200 bg-slate-50">
            <p className="text-xs text-slate-500">Last Login</p>
            <p className="text-sm font-medium text-slate-800 mt-0.5">
              {f.lastLogin
                ? new Date(f.lastLogin).toLocaleString()
                : "—"}
            </p>
          </div>
          <div className="p-3 rounded-lg border border-slate-200 bg-slate-50">
            <p className="text-xs text-slate-500">Member Since</p>
            <p className="text-sm font-medium text-slate-800 mt-0.5">
              {f.createdAt
                ? new Date(f.createdAt).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "—"}
            </p>
          </div>
        </div>
      </Section>

      {/* ── 6. Services Rendered ── */}
      {Array.isArray(f.servicesRendered) && f.servicesRendered.length > 0 && (
        <Section iconPath={icons.briefcase} title="Services Rendered">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {f.servicesRendered.map((svc, idx) => (
              <ServiceCard key={idx} service={svc} idx={idx} />
            ))}
          </div>
        </Section>
      )}

      {/* ── 7. Admin / Marketer Attribution ── */}
      {(f.createdByAdminName ||
        f.createdByMarketerName) && (
        <Section iconPath={icons.users} title="Account Attribution">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {f.createdByAdminName && (
              <>
                <div>
                  <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-1">
                    Created by Admin
                  </p>
                  <p className="text-sm font-medium text-slate-800">
                    {f.createdByAdminName}
                  </p>
                  {f.createdByAdminEmail && (
                    <p className="text-xs text-slate-500">
                      {f.createdByAdminEmail}
                    </p>
                  )}
                </div>
              </>
            )}
            {f.createdByMarketerName && (
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold mb-1">
                  Referred by Marketer
                </p>
                <p className="text-sm font-medium text-slate-800">
                  {f.createdByMarketerName}
                </p>
                {f.createdByMarketerEmail && (
                  <p className="text-xs text-slate-500">
                    {f.createdByMarketerEmail}
                  </p>
                )}
              </div>
            )}
          </div>
        </Section>
      )}

      {/* ── unique ID ── */}
      {f.uniqueNumber && (
        <div className="flex items-center gap-2 px-4 py-3 rounded-lg border border-slate-200 bg-slate-50">
          <span className="text-xs text-slate-500">Unique ID:</span>
          <code className="text-xs font-mono text-slate-700 break-all">
            {f.uniqueNumber}
          </code>
        </div>
      )}
    </div>
  );
};

export default ProfileForm;